export default __webpack_public_path__ + "static/winter14-f8d2811e442307b450f88846096312a9.webp";